import Banner from "../../components/Banner";

function Home() {
  return <Banner />;
}

export default Home;
